PJQ.views.timecards.ManageTimeCardsByWeekModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-manage-timecards-week'),
        maxWidth: '1400px',
        minWidth: '600px',
        onSave: _.noop(),
        onDelete: _.noop(),
        timeCardsView: null
    },
    events: {
        'click .last-week': 'lastWeek',
        'click .next-week': 'nextWeek',
        'click div.add-row-options a.dropdown-item': 'newRow',
        'click .timecards-save': 'saveClicked'
    },
    beforeModalCreated: function () {
        let today = new Date(PJQ.helpers.dateHelpers.getDateString(new Date(), PJQ.helpers.dateHelpers.dateFormats.DATE));
        this.startDate = new Date();
        switch (this.options.settings.get('weekStart')) {
            case 0: // Su
                this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay()) % 7);
                break;
            default:
                this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay() + (7 - this.options.settings.get('weekStart'))) % 7);
                break;
        }

        if (this.options.project != null) {
            this.options.permissions = PJQ.app.session.project.permissions;

            let projectContacts = new PJQ.collections.projectContacts.ProjectContacts(null, {
                project: PJQ.app.session.project
            });

            projectContacts.fetch({
                success: _.bind(function () {
                    this.projectContacts = [];

                    if (this.options.permissions.hasPermission('timeCards.canViewAll')) {
                        this.projectContacts = projectContacts.models;

                        // add project user 2 to top if not present
                        if (PJQ.app.session.project.user2) {
                            if (_.size(_.filter(this.projectContacts, function (projectContact) {
                                return projectContact.get('id') === PJQ.app.session.project.user2.get('id');
                            })) === 0) {
                                this.projectContacts.unshift(PJQ.app.session.project.user2);
                            }
                        }

                        // add project user 1 to top if not present
                        if (PJQ.app.session.project.user) {
                            if (_.size(_.filter(this.projectContacts, function (projectContact) {
                                return projectContact.get('id') === PJQ.app.session.project.user.get('id');
                            })) === 0) {
                                this.projectContacts.unshift(PJQ.app.session.project.user);
                            }
                        }
                    }

                    // add current user to top if not present
                    if (_.size(_.filter(this.projectContacts, function (projectContact) {
                        return projectContact.get('id') === PJQ.app.session.user.get('id');
                    })) === 0) {
                        this.projectContacts.unshift(PJQ.app.session.user);
                    }

                    this.projectContacts = _.sortBy(this.projectContacts, function (user) {
                        return user.get('contactName') ? user.get('contactName').toLowerCase() : '';
                    });

                    this.render();
                }, this)
            });
        } else {
            this.options.permissions = PJQ.app.session.systemPermissions;

            if (this.options.permissions.hasPermission('timeCards.canViewAll')) {
                PJQ.app.session.fetchUsers(_.bind(function (users) {
                    this.users = _.sortBy(users.models, function (user) {
                        return user.get('contactName') ? user.get('contactName').toLowerCase() : '';
                    });
                    this.render();
                }, this));
            } else {
                this.users = [PJQ.app.session.user];
                this.render();
            }
        }
    },
    afterRender: function () {
        if (!this.users && !this.projectContacts)
            return;

        this.datePicker = new PJQ.inputs.Datepicker({
            el: this.$('.select-week-input'),
            datepickerOptions: {
                defaultDate: this.startDate,
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
            },
            disabledDays: _.filter([0, 1, 2, 3, 4, 5, 6], _.bind(function (day) {
                return day !== this.options.settings.get('weekStart');
            }, this)),
            onChange: _.bind(function (value) {
                this.renderWeek(value);
            }, this)
        });

        if (PJQ.app.session.project) {
            _.each(this.projectContacts, _.bind(function (user) {
                this.$('.select-context').append("<option value='" + user.get('id') + "'>" + user.get('contactName') + "</option>");
            }, this));
        } else {
            _.each(this.users, _.bind(function (user) {
                this.$('.select-context').append("<option value='" + user.get('id') + "'>" + user.get('contactName') + "</option>");
            }, this));
        }

        this.context = PJQ.app.session.user;

        this.contextSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-context'),
            isIntChoices: true,
            isMultiple: false,
            mustSelectValue: true,
            defaultValue: this.context.get('id'),
            onHide: _.bind(function () {
                if (this.context.get('id') !== this.contextSelectPicker.getValue()) {
                    if (PJQ.app.session.project) {
                        _.each(this.projectContacts, _.bind(function (user) {
                            if (user.get('id') === this.contextSelectPicker.getValue()) {
                                this.context = user;
                                this.renderWeek();
                            }
                        }, this));
                    } else {
                        _.each(this.users, _.bind(function (user) {
                            if (user.get('id') === this.contextSelectPicker.getValue()) {
                                this.context = user;
                                this.renderWeek();
                            }
                        }, this));
                    }
                }
            }, this)
        });

        this.renderWeek();
    },
    renderWeek: function (newDate = null) {
        if (newDate)
            this.startDate = newDate;

        this.projects = null;
        this.rows = [];
        this.$('.timecards-list, .add-row-options').empty();
        this.$('.timecards-empty').removeClass('hidden');

        let fnContinue = _.bind(function () {
            this.projects = new PJQ.collections.timecards.TimeCardContextProjects(null, {
                id: this.context.get('id'),
                startDate: this.startDate,
                endDate: PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 7)
            });

            this.projects.fetch({
                success: _.bind(function () {
                    this.$('.add-row-options').append("<a class='dropdown-item hidden no-projects' data-project-id='0' disabled='disabled'><span class='text-muted'>No Projects Available</span></a>");

                    if (PJQ.app.session.project) {
                        let hasLocation = (_.size(PJQ.app.session.project.get('city')) + _.size(PJQ.app.session.project.get('state')) > 0);
                        this.$('.add-row-options').append("<a class='dropdown-item project' data-project-id='" + PJQ.app.session.project.get('projectId') + "' title='" + PJQ.app.session.project.get('projectName') + (hasLocation ? (' - ' + PJQ.app.session.project.get('city') + ', ' + PJQ.app.session.project.get('state')) : '') + "'>" + PJQ.app.session.project.get('projectName') + "</a>");
                    } else if (_.size(this.projects.models) > 0) {
                        _.each(this.projects.models, _.bind(function (project) {
                            let hasLocation = (_.size(project.get('city')) + _.size(project.get('state')) > 0);
                            this.$('.add-row-options').append("<a class='dropdown-item project' data-project-id='" + project.get('projectId') + "' title='" + project.get('projectName') + (hasLocation ? (' - ' + project.get('city') + ', ' + project.get('state')) : '') + "'>" + project.get('projectName') + "</a>");
                        }, this));
                    } else {
                        this.$('.add-row-options .dropdown-item[data-project-id="0"]').removeClass('hidden');
                    }

                    if (_.size(this.categories.models) > 0) {
                        this.$('.add-row-options').append("<div class='dropdown-divider'></div>");
                    }

                    _.each(this.categories.models, _.bind(function (category) {
                        this.$('.add-row-options').append("<a class='dropdown-item category' data-project-id='-" + category.get('timeCardCategoryId') + "'>" + category.get('name') + "</a>");
                    }, this));

                    let dateFormat = "ddd, " + PJQ.helpers.dateHelpers.dateFormats.DATE_MONTH_DAY,
                        tempDate = new Date(this.startDate.valueOf());
                    for (var i = 0; i < 7; i++) {
                        this.$('div.timecards-header div[data-day-column="' + i + '"]').text(PJQ.helpers.dateHelpers.getDateString(tempDate, dateFormat));
                        tempDate.setDate(tempDate.getDate() + 1);
                    }

                    let idFilter = 0;
                    if (this.options.contact)
                        idFilter = this.options.contact.get('id');
                    else {
                        if (!this.options.permissions.hasPermission('contacts.canView') && (PJQ.app.session.project === null || !this.options.permissions.hasPermission('canViewAll')))
                            idFilter = -PJQ.app.session.user.id;
                    }

                    let dateNow = new Date(), parameters = {
                        searchFor: '',
                        startDate: PJQ.helpers.dateHelpers.getDateString(this.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                        endDate: PJQ.helpers.dateHelpers.getDateString(PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 6), PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                        page: 1,
                        pageSize: 2147483646,
                        orderBy: 'project.projectId',
                        orderDirection: 'asc',
                        projectId: PJQ.app.session.project ? PJQ.app.session.project.get('projectId') : 0,
                        idFilter: this.context.get('id'),
                        timeZoneOffset: dateNow.getTimezoneOffset()
                    }, timecards = new PJQ.collections.timecards.TimeCards();

                    timecards.fetch({
                        data: parameters,
                        success: _.bind(function () {
                            let newRows = [];
                            _.each(timecards.models, _.bind(function (timecard) {
                                if (_.size(_.filter(newRows, function (row) {
                                    return row.project.projectId == timecard.get('projectId');
                                })) === 0) {
                                    // iterate through the models in each newRow and add any missing dates for this date range.
                                    let models = [];

                                    for (let j = 0; j < 7; j++) {
                                        let date = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, j),
                                            sourceModels = _.filter(timecards.models, function (timecard2) {
                                                return timecard2.projectId === timecard.projectId;
                                            });

                                        let existingModels = _.filter(sourceModels, function (timecard2) {
                                            return timecard2.get('projectId') === timecard.get('projectId') && timecard2.get('date').getTime() === PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, false)).getTime();
                                        });

                                        if (_.size(existingModels) === 0) {
                                            models.push(new PJQ.models.timecards.TimeCard({
                                                projectId: timecard.get('projectId'),
                                                project: timecard.get('project'),
                                                contact: timecard.get('contact'),
                                                id: timecard.get('id'),
                                                date: PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, false)),
                                                notes: '',
                                                regularHours: 0,
                                                overtimeHours: 0,
                                                doubletimeHours: 0,
                                                createdBy: -PJQ.app.session.user.id
                                            }));
                                        } else {
                                            models.push(existingModels[0]);
                                        }
                                    }

                                    newRows.push({
                                        project: timecard.get('project'),
                                        models: models
                                    });
                                }
                            }, this));

                            if (_.size(newRows) > 0) {
                                _.each(newRows, _.bind(function (newRow) {
                                    this.addRow(newRow);
                                }, this));
                            } else if (PJQ.app.session.project) {
                                this.$('.add-row-options .dropdown-item.project[data-project-id="' + PJQ.app.session.project.get('projectId') + '"]').click();
                            }
                        }, this)
                    });

                    this.recalculateTotals();
                }, this)
            });
        }, this);

        // load categories
        if (this.categories == null) {
            this.categories = new PJQ.collections.timecards.TimeCardCategories();
            this.categories.fetch({
                success: _.bind(function () {
                    fnContinue();
                }, this)
            });
        } else {
            fnContinue();
        }
    },
    captureSignature: function (callback) {
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_TIMECARDS_SIGNATURE)) {
            new PJQ.views.signatures.SignatureSubmitModal({
                headerSubText: "Sign off on your time card changes",
                onSubmit: _.bind(function (signature, cb) {
                    cb();
                    callback(signature ? signature : "");
                }, this)
            });
        } else {
            callback(null);
        }
    },
    lastWeek: function () {
        let fnContinue = _.bind(function () {
            let date = new Date(this.startDate.valueOf());
            date.setDate(date.getDate() - 7);
            this.datePicker.setValue(date);
            this.renderWeek(date);
        }, this);

        if (_.size(this.rows) > 0) {

            this.save(_.bind(function () {
                fnContinue();
            }, this));

        } else
            fnContinue();
    },
    nextWeek: function () {
        let fnContinue = _.bind(function () {
            let date = new Date(this.startDate.valueOf());
            date.setDate(date.getDate() + 7);
            this.datePicker.setValue(date);
            this.renderWeek(date)
        }, this);

        if (_.size(this.rows) > 0) {
            this.save(_.bind(function () {
                fnContinue();
            }, this));
        } else
            fnContinue();
    },
    newRow: function (e) {
        let projectId = $(e.currentTarget).data('projectId'), newRow = {};

        if (projectId === 0)
            return;

        if (projectId > 0) {
            _.each(this.projects.models, _.bind(function (project) {
                if (project.get('id') == projectId) {
                    newRow.project = project.attributes;
                }
            }, this));

            if (!newRow.project && PJQ.app.session.project)
                newRow.project = PJQ.app.session.project.attributes;
        } else {
            // find category
            _.each(this.categories.models, _.bind(function (category) {
                if (category.get('timeCardCategoryId') == projectId * -1) {
                    newRow.project = {
                        projectId: category.get('timeCardCategoryId') * -1,
                        projectName: category.get('name')
                    };
                }
            }, this));
        }

        // add new models for the days of this work week
        newRow.models = [];
        for (let i = 0; i < 7; i++) {
            let date = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, i);
            newRow.models.push(new PJQ.models.timecards.TimeCard({
                projectId: projectId,
                project: newRow.project,
                contact: this.context.attributes,
                id: this.context.get('id'),
                date: PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, false)),
                notes: '',
                regularHours: 0,
                overtimeHours: 0,
                doubletimeHours: 0,
                createdBy: -PJQ.app.session.user.id
            }));
        }

        this.addRow(newRow);
    },
    addRow: function (row) {
        this.$('.timecards-empty').addClass('hidden');
        this.$('.add-row-options a.dropdown-item[data-project-id="' + row.project.projectId + '"]').addClass('hidden');
        if (_.size(this.$('.add-row-options a.dropdown-item.category:not(.hidden)')) === 0)
            this.$('.add-row-options .dropdown-divider').addClass('hidden');

        if (_.size(this.$('.add-row-options a.dropdown-item.project:not(.hidden)')) === 0)
            this.$('.add-row-options .dropdown-item.no-projects').removeClass('hidden');

        let self = this;
        this.rows.push(new PJQ.inputs.timecards.TimeCardWeekEditor({
            el: $('<div class="time-card-week" />').appendTo(this.$('.timecards-list')),
            settings: this.options.settings,
            project: this.options.project,
            row: row,
            startDate: this.startDate,
            onChange: _.bind(function () {
                setTimeout(function () {
                    self.recalculateTotals();
                }, 200);
            }, this),
            onDelete: function () {
                this.el.addClass('hidden');
                self.$('.add-row-options a.dropdown-item[data-project-id="' + row.project.projectId + '"]').removeClass('hidden');

                // handle New Row dropdowns depending on if project or category
                if (this.row.project.projectId > 0) {
                    // if at least one visible project in the list exists, hide the 'no projects' item
                    if (_.size(self.$('.add-row-options a.dropdown-item.project:not(.hidden)')) > 0)
                        self.$('.add-row-options .dropdown-item.no-projects').addClass('hidden');
                    else
                        self.$('.add-row-options .dropdown-item.no-projects').removeClass('hidden');
                } else {
                    // at least one category now exists, so show the divider
                    self.$('.add-row-options .dropdown-divider').removeClass('hidden');
                }

                if (_.size(self.$('.timecards-list .time-card-week:not(".hidden")')) == 0)
                    self.$('.timecards-empty').removeClass('hidden');

                self.recalculateTotals();
            }
        }));
    },
    recalculateTotals: function () {
        let grandTotalMinutes = 0;
        for (let i = 0; i < 7; i++) {
            let totalMinutes = 0;

            // loop through each day, and then through each row and get the daytotal
            let date = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, i);
            _.each(this.rows, _.bind(function (row) {
                totalMinutes += row.getTotalTimeForDate(date);
            }, this));

            grandTotalMinutes += totalMinutes;

            this.$('.timecards-footer .time-card-day-total[data-day-column="' + i + '"]').text(PJQ.helpers.timecards.getFormattedTime(totalMinutes));
        }

        this.$('.timecards-footer .time-card-total[data-day-column="total"]').text(PJQ.helpers.timecards.getFormattedTime(grandTotalMinutes));
    },
    save: function (callback) {
        let timecards = [];
        _.each(this.rows, _.bind(function (row) {
            if (row.hasChanges()) {
                timecards.push(..._.filter(row.options.row.models, function (model) {
                    return !model.isNew() || !model.get('deletedOn');
                }));
            }
        }, this));

        let signTimecards = _.filter(timecards, function (timecard) {
            return timecard.get('id') === -PJQ.app.session.user.id;
        }), fnSave = _.bind(function (signature) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'timecards',
                    },
                    {
                        endpoint: 'batch'
                    }
                ]),
                data: {
                    signature: signature,
                    rows: timecards
                },
                isAPIv2: true
            }).post().success(_.bind(function (data) {
                PJQ.notifications.notify.successNotify({
                    message: 'Timecard changes saved sucessfully'
                });
                this.options.onSave();
                callback();
            }, this));
        }, this)
        if (_.size(signTimecards) > 0) {
            this.captureSignature(_.bind(function (signature) {
                fnSave(signature);
            }, this));
        } else if (_.size(timecards) > 0) {
            fnSave();
        } else {
            callback();
        }
    },
    saveClicked: function () {
        this.save(_.bind(function () {
            this.removeModal();
        }, this));
    }
});